import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { YModal, YImage } from '@components/index';
import { get } from 'lodash/object';
import { digits } from '@nodes/helpers/number';
import Props from './props';

interface ModalRef extends Vue {
    open(): void;
}

@Component({
    components: {
        YImage,
        YModal,
    },
})

/**
 * @name ImageGallery
 */
export default class ImageGallery extends Mixins(HybridMixin, Props) {
    digits = digits;

    /**
     * Refs types
     */
    $refs!: {
        albumModal: ModalRef;
    };

    /**
     * Image src witch is selected in modal images list
     */
    selectedModalImage: any = this.getValue('album').find((p: any) => p.mime_type.includes('image'));

    /**
     * Return best version of image
     *
     * @param {object} img
     * @returns {string}
     */
    imgSrc(img: any): string {
        return get(img, `versions.${this.getValue('imageVersion')}`, img.link);
    }

    /**
     * Set selected item of image list in modal slides to Original Image
     *
     * @param {object} img
     */
    setOriginalImage(img: any) {
        this.selectedModalImage = img;
    }

    /**
     * Open image gallery modal
     *
     * @param {*} item - item object
     */
    openModal(item?: any) {
        if (item && item.mime_type) {
            this.setOriginalImage(item);
        }
        this.$refs.albumModal.open();
    }
}
